var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEduBlank(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u56FE\u6807/\u7F3A\u7701\u9875/\u6682\u65E0\u8BFE\u7A0B") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u6807/\\u7F3A\\u7701\\u9875/\\u6682\\u65E0\\u8BFE\\u7A0B",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,13 L64,13 L64,71 L12,71 C10.3431458,71 9,69.6568542 9,68 L9,16 C9,14.3431458 10.3431458,13 12,13 Z",
    id: "\\u5C01\\u9762",
    fill: "#CAEBDC"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u4FA7\\u8FB9",
    transform: "translate(64.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "\\u77E9\\u5F62",
    fill: "#E0E0E0",
    points: "0 0 7 0 7 1.31616211 0 1.31616211"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5,1.27970693 C5.04714737,1.27970693 6.38207382,0.760990144 7.00026175,0.0115758606 L7,57.819458 L6.75015599e-14,57.819458 L0.000563657397,0.0125758316 C0.619113878,0.761451533 1.95354086,1.27970693 3.5,1.27970693 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,1.81945801 L2,57.819458 L1,57.819458 L1,1.81945801 L2,1.81945801 Z M4,1.81945801 L4,57.819458 L3,57.819458 L3,1.81945801 L4,1.81945801 Z M6,1.81945801 L6,57.819458 L5,57.819458 L5,1.81945801 L6,1.81945801 Z",
    id: "\\u5F62\\u72B6\\u7ED3\\u5408",
    fill: "#C1E1D3",
    opacity: 0.400000006
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u4E66\\u7B7E",
    transform: "translate(16.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.6561198,0 L30,0 C31.5976809,0 32.9036609,1.24891996 32.9949073,2.82372721 L33,3 L24.6561198,3 L24.6561198,0 Z",
    id: "\\u77E9\\u5F62",
    fill: "#82B8A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1735026,8.80000795e-05 C27.5040688,-0.013005839 27.0259504,2.34041971 27.000607,3.95368879 L27,38 L13.5,30.9273397 L0,38 L0,4 C0,1.790861 1.790861,0 4,0 L30.1735026,8.80000795e-05 Z",
    id: "\\u5F62\\u72B6\\u7ED3\\u5408",
    fill: "#84D6B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5,21.75 L9.40056143,23.9052024 C9.15613914,24.0337028 8.85382556,23.9397295 8.72532516,23.6953072 C8.67415562,23.597977 8.65649829,23.486493 8.67508671,23.3781142 L9.45800981,18.8133222 L6.14149434,15.5805186 C5.94375255,15.387768 5.93970639,15.0712114 6.132457,14.8734696 C6.2092113,14.7947278 6.30978251,14.7434842 6.41860102,14.7276719 L11.0019127,14.0616778 L13.051632,9.90849288 C13.1738431,9.66086605 13.473656,9.55919655 13.7212829,9.68140769 C13.8198892,9.73007281 13.8997029,9.80988657 13.948368,9.90849288 L15.9980873,14.0616778 L20.581399,14.7276719 C20.8546714,14.7673807 21.0440121,15.0211022 21.0043033,15.2943746 C20.9884911,15.4031931 20.9372475,15.5037643 20.8585057,15.5805186 L17.5419902,18.8133222 L18.3249133,23.3781142 C18.3715938,23.6502824 18.1887999,23.9087603 17.9166317,23.9554408 C17.8082528,23.9740293 17.6967688,23.9563719 17.5994386,23.9052024 L13.5,21.75 Z",
    id: "\\u661F\\u5F62",
    fill: "#FFFFFF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEduBlank);
export default __webpack_public_path__ + "static/media/edu_blank.d5decef22342f6b491e7a4f60ba0a0c7.svg";
export { ForwardRef as ReactComponent };